"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("../classnames"));
var Spacer = function () { return react_1.default.createElement("span", { "aria-hidden": "true", className: "chq-pag--sp" }, "..."); };
var PageLink = function (_a) {
    var disabled = _a.disabled, children = _a.children, current = _a.current, onClick = _a.onClick, page = _a.page;
    var onButtonClick = function () {
        if (!current) {
            onClick(page);
        }
    };
    return (react_1.default.createElement("button", { type: "button", disabled: disabled, "aria-current": current, className: "chq-pag--bn", onClick: onButtonClick }, children));
};
var Page = function (_a) {
    var page = _a.page, props = __rest(_a, ["page"]);
    return (react_1.default.createElement(PageLink, __assign({ page: page }, props), page));
};
var PrevPage = function (_a) {
    var currentPage = _a.currentPage, onClick = _a.onClick;
    return (react_1.default.createElement(PageLink, { disabled: currentPage === 1, page: currentPage - 1, onClick: onClick }, "\u00AB"));
};
var NextPage = function (_a) {
    var currentPage = _a.currentPage, totalPages = _a.totalPages, onClick = _a.onClick;
    return (react_1.default.createElement(PageLink, { disabled: currentPage === totalPages, page: currentPage + 1, onClick: onClick }, "\u00BB"));
};
var Pagination = function (_a) {
    var className = _a.className, _b = _a.currentPage, currentPage = _b === void 0 ? 1 : _b, totalPages = _a.totalPages, onClick = _a.onClick;
    if (totalPages < 2) {
        return null;
    }
    var innerWindow = (__spreadArrays(Array(5)).map(function (empty, index) { return index + currentPage - 2; })
        .filter(function (page) { return page >= 1 && page <= totalPages; }));
    return (react_1.default.createElement("nav", { className: classnames_1.default("chq-pag", className) },
        react_1.default.createElement(PrevPage, { currentPage: currentPage, onClick: onClick }),
        currentPage > 3 && react_1.default.createElement(Page, { page: 1, onClick: onClick }),
        currentPage > 4 && (currentPage === 5 ? react_1.default.createElement(Page, { page: 2, onClick: onClick }) : react_1.default.createElement(Spacer, null)),
        innerWindow.map(function (page) { return (react_1.default.createElement(Page, { key: page, page: page, current: page === currentPage, onClick: onClick })); }),
        currentPage < totalPages - 3 && (currentPage === totalPages - 4
            ? react_1.default.createElement(Page, { page: totalPages - 1, onClick: onClick })
            : react_1.default.createElement(Spacer, null)),
        currentPage < totalPages - 2 && react_1.default.createElement(Page, { page: totalPages, onClick: onClick }),
        react_1.default.createElement(NextPage, { currentPage: currentPage, totalPages: totalPages, onClick: onClick })));
};
exports.default = Pagination;
